import{n as o,o as r}from"./chunk-5NG2JD2X.js";var m=new o({locale:r});export{m as a};
